import React from 'react'
import PropTypes from 'prop-types'

import { values } from 'lodash'

import classes from 'classnames'

import { translate } from 'parking-react-common'

import { ui } from '../redux'

import Icon from '../components/Icon'
import LoadingIndicator from '../components/LoadingIndicator'

const SearchInput = (props) => {
    const { value, size, placeholder, onChange, isSearching, t } = props
    return (
        <div className="form-group has-feedback">
            <input
                className={ classes('form-control', `input-${size}`) }
                value={ value }
                placeholder={ placeholder || t('Type to search...') }
                onChange={ onChange }
                type="text"
            />
            <span className="form-control-feedback">
                { isSearching
                    ? <LoadingIndicator style={ { marginTop: 5 } } size={ 18 } isVisible />
                    : <Icon name="md/search" size={ 22 } />
                }
            </span>
        </div>
    )
}

SearchInput.propTypes = {
    value       : PropTypes.string,
    size        : PropTypes.oneOf(values(ui.SIZE)),
    placeholder : PropTypes.string,
    onChange    : PropTypes.func,
    isSearching : PropTypes.bool
}

SearchInput.defaultProps = {
    size        : ui.SIZE.default,
    isSearching : false
}

export default translate()(SearchInput)
